import { AxiosResponse } from "axios";
import { useCallback, useEffect, useState } from "react";
import useAxios from "../../utils/useAxios";

interface iFetchFusionSupplier {
  fetchFn: () => Promise<AxiosResponse<any, any>>;
  setIsLoading: (isLoading: boolean) => void;
  setData: (data: any) => void;
}

const fetchFusionSupplier = async ({
  fetchFn,
  setIsLoading,
  setData,
}: iFetchFusionSupplier): Promise<void> => {
  const res = await fetchFn();

  setIsLoading(true);
  if (res.status === 200) {
    setData(res.data);
    setIsLoading(false);
    return;
  }

  setIsLoading(false);
  setData([]);
  return;
};

export const useFusionSupplier = () => {
  const axios = useAxios();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<[]>([]);

  const getData = useCallback(
    async () =>
      fetchFusionSupplier({
        fetchFn: () => axios.get("fusion-supplier"),
        setIsLoading: setIsLoading,
        setData,
      }),
    [],
  );

  useEffect(() => {
    getData();
  }, []);

  return { data: data, isLoading: isLoading };
};
